import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=c1511612&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/errorPage.scss?vue&type=style&index=0&id=c1511612&prod&lang=scsss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1511612",
  null
  
)

export default component.exports